/* eslint-disable vue/no-parsing-error */
<!-- eslint-disable max-len -->
<template>
  <div>
    <div class="block relative w-full mt-2">
      <div class="body_inners pl-4 pr-4">
        <div class="title-block block relative mb-2">
          <h2
            class="
              title-block
              block
              text-lgg
              font-bold
              m-0
              text-darkblack text-center
            "
          >
            {{ $t("pages.request_information.request_information") }}
          </h2>
          <p
            class="
              block
              text-darkgray1 text-xs
              font-normal
              mt-2
              mb-0
              title-block
              text-left
            "
          >
            {{ $t("pages.request_information.more_infomation") }}
          </p>
        </div>
        <div
          v-if="loggedIn"
          class="
            block
            relative
            walter-block
            bg-white
            rounded-lg
            walter-shadow
            mb-4
          "
        >
          <div class="flex align-start justify-start top-block mb-0 p-4">
            <div class="left-block w-2/4 relative">
              <h4
                class="
                  block
                  relative
                  text-sm
                  font-bold
                  text-darkblack
                  flex
                  items-center
                  justify-start
                "
              >
                {{ $t("pages.common.buttons.dis73") }}:
                {{ details.customer ? details.customer.id : "" }}
                <span class="flex ml-1.5">
                  <svg
                    class="w-3.5 h-3.5"
                    viewBox="0 0 14 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M5.2689 1.16248C5.38881 1.14971 5.51671 1.18009 5.63283 1.26143L6.21616 1.67029C6.73932 2.0362 7.44074 2.03665 7.96356 1.67029L8.54624 1.26143C8.8559 1.04451 9.25191 1.18848 9.34963 1.55375L9.53322 2.2419C9.69814 2.8585 10.2352 3.30883 10.8711 3.3643L11.5801 3.42615C11.9567 3.45901 12.1676 3.82404 12.0078 4.16638L11.7064 4.81156C11.4365 5.38997 11.5581 6.08039 12.0098 6.53162L12.513 7.03487C12.7803 7.30194 12.7072 7.71698 12.3646 7.87667L11.7194 8.17745C11.1406 8.44679 10.7907 9.0535 10.8464 9.68917L10.9089 10.3988C10.9419 10.7754 10.6187 11.0463 10.2539 10.9483L9.56642 10.7634C8.9499 10.598 8.29107 10.8375 7.92515 11.3604L7.51694 11.9437C7.30021 12.2535 6.87886 12.2542 6.66213 11.9444L6.25392 11.3604C5.888 10.8375 5.22982 10.598 4.6133 10.7634L3.92515 10.9483C3.56032 11.0463 3.23781 10.7754 3.27085 10.3988L3.33335 9.68982C3.38931 9.05391 3.03863 8.44623 2.45965 8.1768L1.81447 7.87667C1.4717 7.71692 1.3985 7.3024 1.66603 7.03487L2.16994 6.53162C2.62166 6.08039 2.74321 5.38997 2.47332 4.81156L2.17189 4.16638C2.01209 3.82404 2.22239 3.45901 2.59898 3.42615L3.30861 3.3643C3.94453 3.30883 4.48093 2.8585 4.64585 2.2419L4.8301 1.55375C4.87895 1.37112 5.0025 1.24371 5.15236 1.18917C5.18983 1.17553 5.22892 1.16673 5.2689 1.16248ZM9.1465 4.6462C9.23711 4.55311 9.3604 4.49894 9.49025 4.49516C9.5909 4.49226 9.69008 4.51981 9.77481 4.57421C9.85954 4.62861 9.92587 4.70732 9.96513 4.80005C10.0044 4.89277 10.0147 4.99518 9.99482 5.09389C9.97491 5.19259 9.92567 5.28298 9.85353 5.35323L6.5202 8.68656C6.42643 8.7803 6.29927 8.83295 6.16668 8.83295C6.0341 8.83295 5.90694 8.7803 5.81317 8.68656L4.1465 7.0199C4.09852 6.97382 4.06021 6.91864 4.03381 6.85758C4.00742 6.79651 3.99348 6.7308 3.9928 6.66428C3.99213 6.59776 4.00473 6.53177 4.02988 6.47018C4.05502 6.4086 4.0922 6.35264 4.13924 6.3056C4.18628 6.25856 4.24223 6.22139 4.30382 6.19624C4.36541 6.1711 4.43139 6.15849 4.49791 6.15917C4.56443 6.15984 4.63015 6.17379 4.69121 6.20018C4.75228 6.22657 4.80746 6.26488 4.85353 6.31287L6.16668 7.62602L9.1465 4.6462Z"
                      fill="#4890D2"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M7.97267 0.442424C8.23903 0.255836 8.54113 0.170709 8.83921 0.172892C9.49498 0.177696 10.1302 0.60408 10.3151 1.29529L10.4994 1.98344C10.5564 2.19684 10.7376 2.34901 10.9577 2.3682L11.6673 2.43005C12.7041 2.52052 13.3536 3.64656 12.9134 4.58956L12.6126 5.23474C12.5192 5.435 12.5599 5.66783 12.7162 5.82393L13.2201 6.32719C13.9562 7.06279 13.7305 8.34327 12.7871 8.78292L12.1419 9.0837C11.9416 9.17694 11.8231 9.38184 11.8425 9.60193L11.905 10.3116C11.9959 11.3483 11 12.1838 9.99481 11.9138L9.30731 11.7295C9.09383 11.6723 8.87155 11.7528 8.74481 11.934L8.33661 12.5173C7.74001 13.3701 6.43972 13.3701 5.84312 12.5173L5.43491 11.934C5.30817 11.7528 5.08589 11.6723 4.87241 11.7295L4.18491 11.9138C3.17974 12.1838 2.1838 11.3483 2.27476 10.3116L2.33726 9.60193C2.35663 9.38184 2.23813 9.17694 2.03778 9.0837L1.39194 8.78292C0.448711 8.34333 0.223198 7.06299 0.959001 6.32719L1.46291 5.82393C1.61919 5.66783 1.66052 5.435 1.56707 5.23474L1.26564 4.58891C0.825447 3.64591 1.47564 2.52052 2.51239 2.43005L3.22137 2.3682C3.44145 2.34901 3.62263 2.19684 3.6797 1.98344L3.86395 1.29529C4.06566 0.541243 4.80313 0.102953 5.5189 0.182658C5.75748 0.209227 5.99396 0.293154 6.20705 0.442424L6.78973 0.851278C6.97191 0.9787 7.20815 0.978245 7.38934 0.851278L7.97267 0.442424ZM5.63283 1.26143C5.51671 1.18009 5.38881 1.14971 5.2689 1.16248C5.22892 1.16673 5.18983 1.17553 5.15236 1.18917C5.0025 1.24371 4.87895 1.37112 4.8301 1.55375L4.64585 2.2419C4.48093 2.8585 3.94453 3.30883 3.30861 3.3643L2.59898 3.42615C2.22239 3.45901 2.01209 3.82404 2.17189 4.16638L2.47332 4.81156C2.74321 5.38997 2.62166 6.08039 2.16994 6.53162L1.66603 7.03487C1.3985 7.3024 1.4717 7.71692 1.81447 7.87667L2.45965 8.1768C3.03863 8.44623 3.38931 9.05391 3.33335 9.68982L3.27085 10.3988C3.23781 10.7754 3.56032 11.0463 3.92515 10.9483L4.6133 10.7634C5.22982 10.598 5.888 10.8375 6.25392 11.3604L6.66213 11.9444C6.87886 12.2542 7.30021 12.2535 7.51694 11.9437L7.92515 11.3604C8.29107 10.8375 8.9499 10.598 9.56642 10.7634L10.2539 10.9483C10.6187 11.0463 10.9419 10.7754 10.9089 10.3988L10.8464 9.68917C10.7907 9.0535 11.1406 8.44679 11.7194 8.17745L12.3646 7.87667C12.7072 7.71698 12.7803 7.30194 12.513 7.03487L12.0098 6.53162C11.5581 6.08039 11.4365 5.38997 11.7064 4.81156L12.0078 4.16638C12.1676 3.82404 11.9567 3.45901 11.5801 3.42615L10.8711 3.3643C10.2352 3.30883 9.69814 2.8585 9.53322 2.2419L9.34963 1.55375C9.25191 1.18848 8.8559 1.04451 8.54624 1.26143L7.96356 1.67029C7.44074 2.03665 6.73932 2.0362 6.21616 1.67029L5.63283 1.26143Z"
                      fill="#4890D2"
                    />
                  </svg>
                </span>
              </h4>
              <p
                class="
                  flex
                  items-center
                  justify-start
                  mt-0.5
                  mb-0
                  text-xs
                  font-medium font-medium
                  text-darkgray1
                "
              >
                <span class="mr-1.5">
                  <svg
                    class="w-3.5 h-3.5"
                    viewBox="0 0 10 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.99984 0.666992C2.2667 0.666992 0.0415039 2.89219 0.0415039 5.62533C0.0415039 6.85231 0.491635 7.97757 1.23096 8.84277L1.23324 8.84505L1.23494 8.84733C1.23494 8.84733 3.34426 11.2542 4.09522 11.9708C4.59809 12.4502 5.40102 12.4502 5.90389 11.9708C6.75987 11.1544 8.7653 8.84619 8.7653 8.84619L8.76644 8.84448L8.76815 8.84277C9.50813 7.97756 9.95817 6.85231 9.95817 5.62533C9.95817 2.89219 7.73297 0.666992 4.99984 0.666992ZM4.99984 1.54199C7.26004 1.54199 9.08317 3.36513 9.08317 5.62533C9.08317 6.63893 8.71379 7.55983 8.10278 8.27425C8.09881 8.2788 6.04693 10.6255 5.30005 11.3379C5.12684 11.503 4.87227 11.503 4.69906 11.3379C4.07484 10.7423 1.90266 8.28143 1.89632 8.27425L1.89575 8.27368C1.28556 7.55932 0.916504 6.63865 0.916504 5.62533C0.916504 3.36513 2.73964 1.54199 4.99984 1.54199ZM4.99984 3.87533C4.45296 3.87533 3.98741 4.09616 3.68848 4.43245C3.38955 4.76875 3.24984 5.19998 3.24984 5.62533C3.24984 6.05067 3.38955 6.4819 3.68848 6.8182C3.98741 7.15449 4.45296 7.37533 4.99984 7.37533C5.54671 7.37533 6.01227 7.15449 6.3112 6.8182C6.61013 6.4819 6.74984 6.05067 6.74984 5.62533C6.74984 5.19998 6.61013 4.76875 6.3112 4.43245C6.01227 4.09616 5.54671 3.87533 4.99984 3.87533ZM4.99984 4.75033C5.32796 4.75033 5.51866 4.85762 5.65723 5.01351C5.7958 5.1694 5.87484 5.39442 5.87484 5.62533C5.87484 5.85623 5.7958 6.08125 5.65723 6.23714C5.51866 6.39303 5.32796 6.50033 4.99984 6.50033C4.67171 6.50033 4.48102 6.39303 4.34245 6.23714C4.20388 6.08125 4.12484 5.85623 4.12484 5.62533C4.12484 5.39442 4.20388 5.1694 4.34245 5.01351C4.48102 4.85762 4.67171 4.75033 4.99984 4.75033Z"
                      fill="#676666"
                    />
                  </svg>
                </span>
                {{ details.location }}
              </p>
            </div>

            <div class="right-block w-2/4 relative">
              <p
                class="
                  wishlist-icon
                  relative
                  text-sm text-right
                  flex
                  items-center
                  justify-end
                  mt-0
                  font-bold
                "
              >
                <svg
                  v-if="details.favorite"
                  width="20"
                  height="18"
                  viewBox="0 0 20 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.5 0.5C2.47122 0.5 0 2.97122 0 6C0 8.04808 1.54382 9.97645 3.42578 11.9541C5.30774 13.9318 7.62419 15.9347 9.46973 17.7803C9.61038 17.9209 9.80112 17.9999 10 17.9999C10.1989 17.9999 10.3896 17.9209 10.5303 17.7803C12.3758 15.9347 14.6923 13.9318 16.5742 11.9541C18.4562 9.97645 20 8.04808 20 6C20 2.97122 17.5288 0.5 14.5 0.5C12.7618 0.5 11.2484 1.43324 10 3.01855C8.75159 1.43324 7.23822 0.5 5.5 0.5ZM5.5 2C6.96429 2 8.18315 2.7792 9.36621 4.65039C9.43386 4.75727 9.52744 4.84531 9.63826 4.90632C9.74907 4.96732 9.87351 4.99931 10 4.99931C10.1265 4.99931 10.2509 4.96732 10.3617 4.90632C10.4726 4.84531 10.5661 4.75727 10.6338 4.65039C11.8168 2.7792 13.0357 2 14.5 2C16.7182 2 18.5 3.78178 18.5 6C18.5 7.20192 17.2938 9.02355 15.4883 10.9209C13.8418 12.6511 11.7952 14.4587 10 16.209C8.20484 14.4587 6.15821 12.6511 4.51172 10.9209C2.70618 9.02355 1.5 7.20192 1.5 6C1.5 3.78178 3.28178 2 5.5 2Z"
                    fill="#63B15B"
                  />
                  <path
                    d="M5.5 2C6.96429 2 8.18315 2.7792 9.36621 4.65039C9.43386 4.75727 9.52744 4.84531 9.63826 4.90632C9.74907 4.96732 9.87351 4.99931 10 4.99931C10.1265 4.99931 10.2509 4.96732 10.3617 4.90632C10.4726 4.84531 10.5661 4.75727 10.6338 4.65039C11.8168 2.7792 13.0357 2 14.5 2C16.7182 2 18.5 3.78178 18.5 6C18.5 7.20192 17.2938 9.02355 15.4883 10.9209C13.8418 12.6511 11.7952 14.4587 10 16.209C8.20484 14.4587 6.15821 12.6511 4.51172 10.9209C2.70618 9.02355 1.5 7.20192 1.5 6C1.5 3.78178 3.28178 2 5.5 2Z"
                    fill="#63B15B"
                  />
                </svg>
                <svg
                  v-else
                  width="20"
                  height="18"
                  viewBox="0 0 20 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.5 0.5C2.47122 0.5 0 2.97122 0 6C0 8.04808 1.54382 9.97645 3.42578 11.9541C5.30774 13.9318 7.62419 15.9347 9.46973 17.7803C9.61038 17.9209 9.80112 17.9999 10 17.9999C10.1989 17.9999 10.3896 17.9209 10.5303 17.7803C12.3758 15.9347 14.6923 13.9318 16.5742 11.9541C18.4562 9.97645 20 8.04808 20 6C20 2.97122 17.5288 0.5 14.5 0.5C12.7618 0.5 11.2484 1.43324 10 3.01855C8.75159 1.43324 7.23822 0.5 5.5 0.5ZM5.5 2C6.96429 2 8.18315 2.7792 9.36621 4.65039C9.43386 4.75727 9.52744 4.84531 9.63826 4.90632C9.74907 4.96732 9.87351 4.99931 10 4.99931C10.1265 4.99931 10.2509 4.96732 10.3617 4.90632C10.4726 4.84531 10.5661 4.75727 10.6338 4.65039C11.8168 2.7792 13.0357 2 14.5 2C16.7182 2 18.5 3.78178 18.5 6C18.5 7.20192 17.2938 9.02355 15.4883 10.9209C13.8418 12.6511 11.7952 14.4587 10 16.209C8.20484 14.4587 6.15821 12.6511 4.51172 10.9209C2.70618 9.02355 1.5 7.20192 1.5 6C1.5 3.78178 3.28178 2 5.5 2Z"
                    fill="#63B15B"
                  />
                </svg>
              </p>
            </div>
          </div>
          <div
            class="
              flex
              align-start
              justify-start
              top-block
              mb-0
              pl-4
              pt-0
              pr-4
              pb-4
            "
          >
            <div class="left-block w-2/4 relative" v-if="details.arrival_date">
              <h4
                class="
                  block
                  relative
                  text-sm
                  font-bold
                  text-darkblack
                  flex
                  items-center
                  justify-start
                "
              >
                {{
                  formatDate(details.arrival_date, "DD.MM.YYYY", "YYYY-MM-DD")
                }}
              </h4>
            </div>

            <div class="right-block w-2/4 relative">
              <p
                class="
                  wishlist-icon
                  relative
                  text-smm text-right
                  flex
                  items-center
                  justify-end
                  mt-0
                  font-bold
                "
              >
                <span class="mr-0.5">
                  <svg
                    width="14"
                    height="15"
                    viewBox="0 0 14 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6.99992 0.833008C3.32394 0.833008 0.333252 3.8237 0.333252 7.49967C0.333252 11.1757 3.32394 14.1663 6.99992 14.1663C10.6759 14.1663 13.6666 11.1757 13.6666 7.49967C13.6666 3.8237 10.6759 0.833008 6.99992 0.833008ZM7.1731 3.83301C8.49643 3.83301 9.06283 4.39182 9.5175 4.84082C9.71416 5.03482 9.71605 5.35118 9.52205 5.54785C9.32839 5.74452 9.01102 5.74641 8.81502 5.55241C8.40802 5.15074 8.08675 4.83301 7.17375 4.83301C6.37141 4.83301 5.67052 5.37067 5.29419 6.16634H6.83325C7.10925 6.16634 7.33325 6.39001 7.33325 6.66634C7.33325 6.94267 7.10925 7.16634 6.83325 7.16634H5.0188C5.00747 7.27567 4.99992 7.38667 4.99992 7.49967C4.99992 7.61267 5.00747 7.72367 5.0188 7.83301H6.83325C7.10925 7.83301 7.33325 8.05667 7.33325 8.33301C7.33325 8.60934 7.10925 8.83301 6.83325 8.83301H5.29419C5.67086 9.62867 6.37076 10.1663 7.1731 10.1663C8.0861 10.1663 8.40769 9.84861 8.81502 9.44694C9.01102 9.25294 9.32839 9.25516 9.52205 9.4515C9.71605 9.64816 9.71416 9.96486 9.5175 10.1585C9.06283 10.6079 8.49675 11.1663 7.17375 11.1663C5.83108 11.1663 4.68329 10.1967 4.22062 8.83301H3.49992C3.22392 8.83301 2.99992 8.60934 2.99992 8.33301C2.99992 8.05667 3.22392 7.83301 3.49992 7.83301H4.01489C4.00623 7.72301 3.99992 7.61234 3.99992 7.49967C3.99992 7.38701 4.00623 7.27634 4.01489 7.16634H3.49992C3.22392 7.16634 2.99992 6.94267 2.99992 6.66634C2.99992 6.39001 3.22392 6.16634 3.49992 6.16634H4.21997C4.68297 4.80267 5.83076 3.83301 7.1731 3.83301Z"
                      fill="#63B15B"
                    />
                  </svg>
                </span>
                {{ formatPrice(details.compensation) }} Euro
              </p>
            </div>
          </div>
        </div>
        <div v-if="loggedIn" class="block relative form-group mb-4">
          <label class="block relative text-xs font-bold text-darkgray mb-1">
            {{ $t("pages.faq.more_info") }}
          </label>
          <textarea
            v-model.trim="comment"
            class="
              block
              relative
              border
              solid
              border-color
              pt-3
              pb-3
              pl-4
              pr-4
              text-darkgray
              placeholder-gray
              w-full
              h-24
              resize-none
              outline-none
              shadow-none
              rounded
            "
            :placeholder="$t('pages.common.buttons.dis50')"
          >
          </textarea>
        </div>
        <div v-if="loggedIn" class="form-group mb-8 w-full">
          <button
            class="
              w-full
              flex
              items-center
              justify-center
              rounded
              text-white
              bg-darkgreen
              border
              solid
              border-darkgreen
              text-sm
              font-normal
              pt-3
              pb-3
              pl-3
              pr-3
            "
            :class="{
              'disabled:opacity-50': comment.length === 0,
            }"
            :disabled="comment.length === 0"
            @click="save"
          >
            {{ $t("pages.request_information.submit_information") }}
          </button>
        </div>

        <div
          class="
            block
            relative
            p-4
            info-block
            walter-block
            bg-white
            rounded-lg
            walter-shadow
          "
        >
          <div class="flex align-start justify-start">
            <div class="block relative w-46 h-46 rounded-full">
              <img
                src="./../../assets/images/ellipse.png"
                alt=""
                class="w-full h-full rounded-full"
              />
            </div>
            <div class="block relative pl-4">
              <label
                class="
                  flex flex-wrap
                  text-sm text-darkblack
                  font-bold
                  mb-1.5
                  text-darkgray1
                "
              >
                Mateusz Walas
                <span class="font-normal">
                  {{ $t("pages.common.buttons.dis29") }}
                </span>
              </label>
              <label
                class="
                  flex
                  items-center
                  justify-start
                  text-sm
                  font-normal
                  mb-2
                  text-darkgreen
                "
              >
                <span class="flex mr-1.5">
                  <svg
                    class="w-4 h-4"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.95717 2.30161L0.978577 2.28823L3.68461 0.955078L6.60533 4.84936L5.26158 6.64114C5.30179 7.31687 5.58834 7.9544 6.067 8.43305C6.54566 8.9117 7.1832 9.19825 7.85892 9.23845L9.65067 7.8947L13.5449 10.8154L12.2229 13.4988L12.2117 13.5214L12.1983 13.5428C12.1278 13.6565 12.0293 13.7502 11.9123 13.8151C11.7953 13.8799 11.6636 13.9138 11.5298 13.9133H10.8315C9.48617 13.9133 8.15396 13.6483 6.911 13.1335C5.66803 12.6186 4.53864 11.864 3.58731 10.9127C2.63599 9.96133 1.88136 8.83194 1.36651 7.58898C0.851656 6.34601 0.586666 5.0138 0.58667 3.66842V2.97014C0.586242 2.83635 0.620065 2.70468 0.684917 2.58766C0.749771 2.47064 0.843495 2.37216 0.95717 2.30161ZM1.58667 3.66842C1.58667 8.76608 5.73392 12.9133 10.8315 12.9133H11.3965L12.2811 11.1176L9.65048 9.14464L8.18589 10.243H8.01923C7.0217 10.2419 6.06534 9.84517 5.35998 9.1398C4.65461 8.43444 4.25785 7.47808 4.25673 6.48055V6.31389L5.35514 4.84933L3.38239 2.21886L1.58667 3.10358V3.66842Z"
                      fill="#63B15B"
                    />
                  </svg>
                </span>
                71 584 652
              </label>

              <label
                class="
                  flex
                  items-center
                  justify-start
                  text-sm
                  font-normal
                  mb-2
                  text-darkgreen
                "
              >
                <span class="flex mr-1.5">
                  <svg
                    class="w-4 h-4"
                    viewBox="0 0 14 11"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.4998 0.166992C12.6905 0.166992 13.6665 1.14301 13.6665 2.33366V8.66699C13.6665 9.85764 12.6905 10.8337 11.4998 10.8337H2.49984C1.30919 10.8337 0.33317 9.85764 0.33317 8.66699V2.33366C0.33317 1.14301 1.30919 0.166992 2.49984 0.166992H11.4998ZM11.4998 1.16699H2.49984C1.84982 1.16699 1.33317 1.68364 1.33317 2.33366V2.70215L6.99984 5.7653L12.6665 2.70215V2.33366C12.6665 1.68364 12.1499 1.16699 11.4998 1.16699ZM12.6665 3.83887L7.23747 6.77376C7.16447 6.81319 7.0828 6.83383 6.99984 6.83383C6.91687 6.83383 6.83521 6.81319 6.76221 6.77376L1.33317 3.83887V8.66699C1.33317 9.31701 1.84982 9.83366 2.49984 9.83366H11.4998C12.1499 9.83366 12.6665 9.31701 12.6665 8.66699V3.83887Z"
                      fill="#63B15B"
                    />
                  </svg>
                </span>
                mateusz.walas@gmail.com
              </label>
              <label
                class="
                  flex
                  items-center
                  justify-start
                  text-sm
                  font-normal
                  mb-0
                  text-darkgray1
                "
              >
                <span class="flex mr-1.5">
                  <svg
                    class="w-4 h-4"
                    viewBox="0 0 14 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6.99984 0.833008C10.6758 0.833008 13.6665 3.8237 13.6665 7.49967C13.6665 11.1757 10.6758 14.1663 6.99984 14.1663C3.32386 14.1663 0.33317 11.1757 0.33317 7.49967C0.33317 3.8237 3.32386 0.833008 6.99984 0.833008ZM6.99984 1.83301C3.8643 1.83301 1.33317 4.36414 1.33317 7.49967C1.33317 10.6352 3.8643 13.1663 6.99984 13.1663C10.1354 13.1663 12.6665 10.6352 12.6665 7.49967C12.6665 4.36414 10.1354 1.83301 6.99984 1.83301ZM7.17432 3.49251C7.30681 3.49458 7.43307 3.54916 7.52535 3.64425C7.61764 3.73934 7.6684 3.86718 7.6665 3.99967V7.99967C7.66649 8.13228 7.61381 8.25945 7.52004 8.35321C7.42628 8.44698 7.29911 8.49966 7.1665 8.49967H4.49984C4.43358 8.50061 4.3678 8.48837 4.30631 8.46366C4.24483 8.43896 4.18887 8.40228 4.14169 8.35575C4.0945 8.30923 4.05703 8.2538 4.03146 8.19267C4.00589 8.13154 3.99272 8.06594 3.99272 7.99967C3.99272 7.93341 4.00589 7.86781 4.03146 7.80668C4.05703 7.74555 4.0945 7.69012 4.14169 7.64359C4.18887 7.59707 4.24483 7.56039 4.30631 7.53569C4.3678 7.51098 4.43358 7.49874 4.49984 7.49967H6.6665V3.99967C6.66554 3.93275 6.67803 3.86632 6.70322 3.80431C6.7284 3.7423 6.76578 3.68598 6.81314 3.63869C6.8605 3.59139 6.91687 3.55408 6.97891 3.52898C7.04095 3.50387 7.1074 3.49147 7.17432 3.49251Z"
                      fill="#63B15B"
                    />
                  </svg>
                </span>
                {{ $t("pages.common.buttons.dis5") }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="show"
      class="w-full h-full fixed left-0 top-0 black-overlay"
      @click="displayModal"
    >
      <div
        class="
          w-full
          h-full
          flex
          items-center
          justify-center
          pt-7
          pb-7
          pl-7
          pr-7
        "
      >
        <div class="w-full flex items-center">
          <div class="w-full bg-white h-auto pt-7 pb-7 pl-4 pr-4 rounded-2xl">
            <div class="flex items-center justify-center mb-6">
              <svg
                class="w-14 h-14"
                viewBox="0 0 52 52"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M26.0001 0.166992C11.7557 0.166992 0.166748 11.7559 0.166748 26.0003C0.166748 40.2447 11.7557 51.8337 26.0001 51.8337C40.2445 51.8337 51.8334 40.2447 51.8334 26.0003C51.8334 11.7559 40.2445 0.166992 26.0001 0.166992ZM26.0001 4.04199C38.1503 4.04199 47.9584 13.8501 47.9584 26.0003C47.9584 38.1505 38.1503 47.9587 26.0001 47.9587C13.8499 47.9587 4.04175 38.1505 4.04175 26.0003C4.04175 13.8501 13.8499 4.04199 26.0001 4.04199ZM35.6497 18.2327C35.1466 18.2473 34.6688 18.4572 34.3177 18.818L22.7709 30.3647L17.6825 25.2763C17.5039 25.0903 17.2901 24.9419 17.0535 24.8396C16.8168 24.7374 16.5622 24.6833 16.3044 24.6807C16.0467 24.6781 15.791 24.7269 15.5523 24.8244C15.3137 24.9218 15.0968 25.0659 14.9146 25.2481C14.7323 25.4304 14.5882 25.6472 14.4908 25.8859C14.3934 26.1245 14.3445 26.3802 14.3471 26.638C14.3498 26.8958 14.4038 27.1504 14.506 27.387C14.6083 27.6237 14.7568 27.8375 14.9427 28.016L21.401 34.4744C21.7644 34.8376 22.2571 35.0416 22.7709 35.0416C23.2847 35.0416 23.7774 34.8376 24.1408 34.4744L37.0575 21.5577C37.337 21.2855 37.5278 20.9352 37.605 20.5527C37.6821 20.1703 37.642 19.7734 37.4899 19.4141C37.3378 19.0548 37.0807 18.7498 36.7524 18.539C36.4241 18.3282 36.0398 18.2214 35.6497 18.2327Z"
                  fill="#63B15B"
                />
              </svg>
            </div>
            <h2
              class="
                w-full
                font-bold
                text-smm text-darkblack
                mb-1.5
                text-center
              "
            >
              {{ $t("pages.common.buttons.dis30") }}
            </h2>
            <p
              class="
                w-full
                font-normal
                textsmxs
                text-darkgray1
                mb-6
                text-center
              "
            >
              {{ $t("pages.common.buttons.dis31") }}
            </p>
            <div class="form-group block w-full">
              <button
                class="
                  w-full
                  flex
                  items-center
                  justify-center
                  rounded
                  text-white
                  bg-darkgreen
                  border
                  solid
                  border-darkgreen
                  text-sm
                  font-medium
                  pt-3
                  pb-3
                  pl-3
                  pr-3
                "
                @click="$router.push('/search')"
              >
                {{ $t("pages.common.buttons.dis32") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { StorageService } from "@/services/storage.service";
export default {
  name: "RequestInformation",
  data() {
    return {
      show: false,
      comment: "",
      details: StorageService.get("offerDetails"),
    };
  },

  computed: {
    ...mapGetters("offer", {
      details: "details",
    }),
  },
  methods: {
    formatPrice(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    save() {
      this.loading = true;
      this.$store
        .dispatch("info/requestMoreInfo", {
          comment: this.comment,
          offer_id: this.details.offer_id,
        })
        .then(() => {
          this.comment = "";
          this.loading = false;

          this.$store.commit("app/showNotification", {
            heading: this.$t("pages.common.buttons.dis30"),
            desc: this.$t("pages.common.buttons.dis31"),
            buttons: {
              okay: {
                text: this.$t("pages.common.buttons.dis32"),
                action: () => {
                  this.$router.push({ name: "offerSearch" });
                },
              },
            },
            icon: {
              show: true,
              type: "success",
            },
          });
        });
    },
  },
};
</script>
